function minusSqrt(a) {
  return Math.pow(1 - a, 0.5)
}


function minusRevertTriple(a) {
  return Math.pow(1 - a, 1 / 3)
}

function minus2RevertTriple(a) {
  return Math.pow(1 - a, 2 / 3)
}

export default {
  mechanisms: [
    {
      name: '1 抛物线法则',
      integ: function (a) {
        return a * a
      },
      diff: function (a) {
        return Math.pow(a, -1) / 2.0
      }
    }, {
      name: '2 Valensi方程',
      integ: function (a) {
        var t = 1 - a;
        return a + t * Math.log(t)
      },
      diff: function (a) {
        var t = -Math.log(1 - a);
        return Math.pow(t, -1)
      }
    }, {
      name: '3 Jander方程,2D,n=0.5',
      integ: function (a) {
        return minusSqrt(minusSqrt(a));
      },
      diff: function (a) {
        return 4 * minusSqrt(a) * minusSqrt(minusSqrt(a));
      }
    },
    {
      name: '4 Jander方程,2D,n=2',
      integ: function (a) {
        return Math.pow(1 - minusSqrt(a), 2)
      },
      diff: function (a) {
        return minusSqrt(a) * Math.pow(1 - minusSqrt(a), -1)
      }
    },
    {
      name: '5 Jander方程,3D,n=0.5',
      integ: function (a) {
        let temp = minusRevertTriple(a);
        return minusSqrt(temp)
      },
      diff: function (a) {
        let temp = minusRevertTriple(a);
        return 6 * minus2RevertTriple(a) * minusSqrt(temp);
      }
    },
    {
      name: '6 Jander方程,3D,n=2',
      integ: function (a) {
        return Math.pow(1 - minusRevertTriple(a), 2)
      },
      diff: function (a) {
        return 3 / 2 * minus2RevertTriple(a) * Math.pow(1 - minusRevertTriple(a), -1)
      }
    },
    {
      name: '7 G.-B方程 3D',
      integ: function (a) {
        return 1 - 2 / 3 * a - minus2RevertTriple(a)
      },
      diff: function (a) {
        let temp = Math.pow(1 - a, -1 / 3);
        return 3 / 2 * Math.pow(temp - 1, -1)
      }
    },
    {
      name: '8 反Jander方程 3D',
      integ: function (a) {
        let temp = Math.pow(1 + a, 1 / 3);
        return Math.pow(temp - 1, 2)
      },
      diff: function (a) {
        let temp = Math.pow(1 + a, 1 / 3);
        return 1.5 * Math.pow(1 + a, 2 / 3) * Math.pow(temp - 1, -1)
      }
    },
    {
      name: '9 Z.-L.-T.方程 3D',
      integ: function (a) {
        let temp = Math.pow(1 - a, -1 / 3);
        return Math.pow(temp - 1, 2)
      },
      diff: function (a) {
        let temp = Math.pow(1 - a, -1 / 3);
        return 1.5 * Math.pow(1 - a, 4 / 3) * Math.pow(temp - 1, -1)
      }
    },
    {
      name: '10 Avrami-Erofeev方程 n=1/4,m=4',
      integ: function (a) {
        return Math.pow(-Math.log(1 - a), 1 / 4)
      },
      diff: function (a) {
        return 4 * (1 - a) * Math.pow(-Math.log(1 - a), 3 / 4)
      }
    },
    {
      name: '11 Avrami-Erofeev方程 n=1/3,m=3',
      integ: function (a) {
        return Math.pow(-Math.log(1 - a), 1 / 3)
      },
      diff: function (a) {
        return 3 * (1 - a) * Math.pow(-Math.log(1 - a), 2 / 3)
      }
    },
    {
      name: '12 Avrami-Erofeev方程 n=2/5',
      integ: function (a) {
        return Math.pow(-Math.log(1 - a), 2 / 5)
      },
      diff: function (a) {
        return 2.5 * (1 - a) * Math.pow(-Math.log(1 - a), 3 / 5);
      }
    },
    {
      name: '13 Avrami-Erofeev方程 n=0.5,m=2',
      integ: function (a) {
        return Math.pow(-Math.log(1 - a), 0.5);
      },
      diff: function (a) {
        return 2 * (1 - a) * Math.pow(-Math.log(1 - a), 0.5)
      }
    },
    {
      name: '14 Avrami-Erofeev方程 n=2/3',
      integ: function (a) {
        return Math.pow(-Math.log(1 - a), 2 / 3)
      },
      diff: function (a) {
        return 1.5 * (1 - a) * Math.pow(-Math.log(1 - a), 1 / 3)
      }
    },
    {
      name: '15 Avrami-Erofeev方程 n=3/4',
      integ: function (a) {
        return Math.pow(-Math.log(1 - a), 3 / 4)
      },
      diff: function (a) {
        return 4 / 3 * (1 - a) * Math.pow(-Math.log(1 - a), 1 / 4)
      }
    },
    {
      name: '16 Mample单行法则',
      integ: function (a) {
        return -Math.log(1 - a)
      },
      diff: function (a) {
        return 1 - a;
      }
    },
    {
      name: '17 Avrami-Erofeev方程 n=3/2',
      integ: function (a) {
        return Math.pow(-Math.log(1 - a), 3 / 2)
      },
      diff: function (a) {
        return 2 / 3 * (1 - a) * Math.pow(-Math.log(1 - a), 1 / 2)
      }
    },
    {
      name: '18 Avrami-Erofeev方程 n=2',
      integ: function (a) {
        return Math.pow(-Math.log(1 - a), 2)
      },
      diff: function (a) {
        return 0.5 * (1 - a) * Math.pow(-Math.log(1 - a), -1)
      }
    },
    {
      name: '19 Avrami-Erofeev方程 n=3',
      integ: function (a) {
        return Math.pow(-Math.log(1 - a), 3)
      },
      diff: function (a) {
        return 1 / 3 * (1 - a) * Math.pow(-Math.log(1 - a), -2)
      }
    },
    {
      name: '20 Avrami-Erofeev方程 n=4',
      integ: function (a) {
        return Math.pow(-Math.log(1 - a), 4)
      },
      diff: function (a) {
        return 1 / 4 * (1 - a) * Math.pow(-Math.log(1 - a), -3)
      }
    },
    {
      name: '21 P.-T.方程(***)',
      integ: function (a) {
        return Math.log(a / (1 - a))
      },
      diff: function (a) {
        return a * (1 - a)
      }
    },
    {
      name: '22 Mampel Power法则 n=1/4',
      integ: function (a) {
        return Math.pow(a, 1 / 4)
      },
      diff: function (a) {
        return 4 * Math.pow(a, 3 / 4)
      }
    },
    {
      name: '23 Mampel Power法则 n=1/3',
      integ: function (a) {
        return Math.pow(a, 1 / 3)
      },
      diff: function (a) {
        return Math.pow(a, 2 / 3) * 3
      }
    },
    {
      name: '24 Mampel Power法则 n=1/2',
      integ: function (a) {
        return Math.pow(a, 1 / 2)
      },
      diff: function (a) {
        return Math.pow(a, 1 / 2) * 2
      }
    },
    {
      name: '25 Mampel Power法则 n=1',
      integ: function (a) {
        return a;
      },
      diff: function (a) {
        return 1.0
      }
    },
    {
      name: '26 Mampel Power法则 n=3/2',
      integ: function (a) {
        return Math.pow(a, 3 / 2)
      },
      diff: function (a) {
        return Math.pow(a, 1 / 2) * 2 / 3
      }
    },
    {
      name: '27 Mampel Power法则 n=2',
      integ: function (a) {
        return Math.pow(a, 2)
      },
      diff: function (a) {
        return 0.5 * Math.pow(a, -1)
      }
    },
    {
      name: '28 反应级数 n=1/4',
      integ: function (a) {
        return 1 - Math.pow(1 - a, 1 / 4)
      },
      diff: function (a) {
        return 4 * Math.pow(1 - a, 3 / 4)
      }
    },
    {
      name: '29 收缩球状体 n=1/3',
      integ: function (a) {
        return 1.0 - Math.pow(1 - a, 1 / 3.0)
      },
      diff: function (a) {
        return 3.0 * Math.pow(1 - a, 2 / 3.0)
      }
    },
    {
      name: '30 收缩球状体 n=3',
      integ: function (a) {
        let pow = Math.pow(1 - a, 1.0 / 3.0);
        return 3.0 * (1.0 - pow);
      },
      diff: function (a) {
        return Math.pow(1 - a, 2.0 / 3.0);
      }
    },
    {
      name: '31 收缩园柱体 n=1/2',
      integ: function (a) {
        return 1 - Math.pow(1 - a, 1 / 2)
      },
      diff: function (a) {
        return 2 * Math.pow(1 - a, 1 / 2.0);
      }
    },
    {
      name: '32 收缩园柱体 n=2',
      integ: function (a) {
        return 2 * (1 - Math.pow(1 - a, 1.0 / 2.0));
      },
      diff: function (a) {
        return Math.pow(1 - a, 1.0 / 2.0);
      }
    },
    {
      name: '33 反应级数 n=2',
      integ: function (a) {
        return 1.0 - Math.pow(1 - a, 2);
      },
      diff: function (a) {
        return 0.5 * Math.pow(1 - a, -1.0);
      }
    },
    {
      name: '34 反应级数 n=3',
      integ: function (a) {
        return 1.0 - Math.pow(1 - a, 3);
      },
      diff: function (a) {
        return Math.pow(1 - a, -2) / 3.0;
      }
    },
    {
      name: '35 反应级数 n=4',
      integ: function (a) {
        return 1 - Math.pow(1 - a, 4);
      },
      diff: function (a) {
        return Math.pow(1 - a, -3.0) / 4.0;
      }
    },
    {
      name: '36 二级 化学反应',
      integ: function (a) {
        return Math.pow(1 - a, -1);
      },
      diff: function (a) {
        return Math.pow(1 - a, 2.0);
      }
    },
    {
      name: '37 反应级数 化学反应',
      integ: function (a) {
        return Math.pow(1 - a, -1) - 1;
      },
      diff: function (a) {
        return Math.pow(1 - a, 2);
      }
    },
    {
      name: '38 2/3级 化学反应',
      integ: function (a) {
        return Math.pow(1 - a, -1 / 2);
      },
      diff: function (a) {
        return 2 * Math.pow(1 - a, 3.0 / 2.0);
      }
    },
    {
      name: '39 指数法则 n=1',
      integ: function (a) {
        return Math.log(a)
      },
      diff: function (a) {
        return a;
      }
    },
    {
      name: '40 指数法则 n=2',
      integ: function (a) {
        return Math.log(Math.pow(a, 2))
      },
      diff: function (a) {
        return a / 2.0
      }
    },
    {
      name: '41 三级 化学反应',
      integ: function (a) {
        return Math.pow(1 - a, -2)
      },
      diff: function (a) {
        return Math.pow(1 - a, 3) / 2.0
      }
    },
    {
      name: '42 S-B方程',
      integ: function (a, m, n) {
        return a;
      },
      diff: function (a, m, n) {
        return Math.pow(a, m) * Math.pow((1 - a), n);
      }
    },
    {
      name: '43 反应级数 化学反应',
      integ: function (a, m, n) {
        let temp = 1 - n;
        return (1 - Math.pow((1 - a), temp)) / temp;
      },
      diff: function (a, m, n) {
        return Math.pow((1 - a), n)
      }
    },
    {
      name: '44 J-M-A方程',
      integ: function (a, m, n) {
        return Math.pow(-Math.log(1 - a), 1 / n);
      },
      diff: function (a, m, n) {
        let temp = 1 - a;
        return n * temp * Math.pow(-Math.log(temp), 1 - 1 / n);
      }
    },
    {
      name: '45 幂函数法则',
      integ: function (a, m, n) {
        return Math.pow(a, 1 / n);
      },
      diff: function (a, m, n) {
        return n * Math.pow(a, (n - 1) / n);
      }
    }
  ],
  default_high_charts_option: {
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    credits: {
      enabled: false
    },
    xAxis: {
      title: {
        text: null
      }
    },
    yAxis: {
      title: {
        text: null
      }
    },
    series: []
  }
}



// WEBPACK FOOTER //
// ./src/components/equation.js